// Dev-only tier switcher (account menu). Dead-code-eliminated from prod builds.
import { MenuItem, Divider } from '@mui/material';
import { useAuth } from '@/features/auth/useAuth';
import { useTier } from '@/features/tier';
import { setUserTier } from '@/services/userService';
import { useT } from '@/i18n/useT';

const TIERS = /** @type {const} */ (['free', 'lite', 'pro']);

export default function DevTierSwitcher({ onSelect }) {
  const { user } = useAuth();
  const { tier } = useTier();
  const t = useT();

  if (!import.meta.env.DEV || !user?.uid) return null;

  return (
    <>
      <Divider />
      {TIERS.map((tierOption) => (
        <MenuItem
          key={tierOption}
          selected={tierOption === tier}
          onClick={() => {
            setUserTier(user.uid, tierOption);
            onSelect?.();
          }}
        >
          {t('appbar.devTierSwitch', 'Dev: tier →')} {tierOption}
        </MenuItem>
      ))}
    </>
  );
}
